import React from 'react';

import './style.css';

const About = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <div className="wpo-about-area section-padding">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-12 colsm-12">
            <div className="wpo-about-text">
              <div className="wpo-section-title">
                <span>What We Do?</span>
                <h2>Our Mission</h2>
              </div>
              <p>
                LHCF promote Children and Human Rights. We provide Psychosocial,
                Educational, and Economic support to children in need, so that
                they may become independent agents of development in their
                communities.
              </p>
              <div className="btns">
                <a href="/donate" className="theme-btn" onClick={ClickHandler}>
                  Donate Now
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-12 colsm-12">
            {/* TODO: USE THE ORGANIZATION'S VIDEO ONCE UPLOADED TO THEIR YOUTUBE CHANNEL */}
            {/*
            <div className="wpo-about-banner">
              <iframe
                className="youtube-video"
                src="https://www.youtube.com/embed/0iPYFm1ZE0A"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title="gaso g"
              ></iframe> 
            </div>
            */}
            {/* REMOVE THIS ONCE THE VIDEO IS AVAILABLE */}
            <div className="wpo-about-banner"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
